module.exports = __webpack_public_path__ + "static/img/4.1ba3560.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/4.jpg
// module id = slXk
// module chunks = 18